import PropTypes from 'prop-types';

import {resolveBackground} from '#core/utils/color-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import RANGE_INPUT from './range-input.palette-schema.yaml';

const OPTIONS_SCHEMA = {
    POINTER_EVENTS: PropTypes.string,
    BORDER_RADIUS: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

registerTileSchema(RANGE_INPUT);

/* generateRangeInput and generateSlider are similar but for different components */
/* generateRangeInput is for auto cash-out which is more like progress bar */

export function generateRangeInput(TILE, OPTIONS = {}) {
    PropTypes.checkPropTypes(OPTIONS_SCHEMA, OPTIONS, 'RANGE_INPUT_OPTIONS', 'RangeInput Generator');

    return {
        component: generateRangeInputComponent(TILE, OPTIONS),
        labels: generateRangeInputLabels(TILE),
    };
}

export function generateRangeInputComponent(TILE, OPTIONS = {}) {
    return {
        style: {
            input: {
                backgroundImage: `linear-gradient(${TILE.RANGE_TRACK_FILLED_COLOR}, ${TILE.RANGE_TRACK_FILLED_COLOR}), linear-gradient(${TILE.RANGE_TRACK_COLOR}, ${TILE.RANGE_TRACK_COLOR})`,
                disabledBackgroundImage: `linear-gradient(${TILE.RANGE_TRACK_DISABLED_FILLED_COLOR}, ${TILE.RANGE_TRACK_DISABLED_FILLED_COLOR}), linear-gradient(${TILE.RANGE_TRACK_DISABLED_COLOR}, ${TILE.RANGE_TRACK_DISABLED_COLOR})`,
                pointerEvents: OPTIONS.POINTER_EVENTS,
                borderRadius: OPTIONS.BORDER_RADIUS || '4px',
            },
            thumb: {
                ...resolveBackground(TILE.RANGE_THUMB_COLOR),
            },
            disabled: {
                thumb: {
                    ...resolveBackground(TILE.RANGE_THUMB_DISABLED_COLOR),
                },
            },
        },
    };
}

/* this should be as a part of rangeInputGenerator as soon as Mojito stars support labels for rangeInput */
export function generateRangeInputLabels(TILE) {
    const {FONT} = TILE;
    const RANGE_LABEL_TEXT_STYLE = {
        style: {
            fontSize: FONT.SIZE_XSMALL,
            ...TILE.RANGE_LABEL_TEXT,
        },
    };
    return {
        rangeMinLabel: RANGE_LABEL_TEXT_STYLE,
        rangeMinValue: RANGE_LABEL_TEXT_STYLE,
        rangeMaxLabel: RANGE_LABEL_TEXT_STYLE,
        rangeMaxValue: RANGE_LABEL_TEXT_STYLE,
    };
}

/* generateSlider is for slider in Total points/handicap markets */
/* generateSlider requires no RANGE_TRACK_FILLED_COLOR */

export function generateSlider(TILE, OPTIONS = {}) {
    PropTypes.checkPropTypes(OPTIONS_SCHEMA, OPTIONS, 'RANGE_INPUT_OPTIONS', 'RangeInput Generator');

    return {
        component: generateSliderComponent(TILE, OPTIONS),
        labels: generateSliderLabels(TILE),
    };
}

export function generateSliderComponent(TILE, OPTIONS) {
    return {
        style: {
            input: {
                backgroundImage: `linear-gradient(${TILE.RANGE_TRACK_COLOR}, ${TILE.RANGE_TRACK_COLOR}),linear-gradient(${TILE.RANGE_TRACK_COLOR}, ${TILE.RANGE_TRACK_COLOR})`,
                disabledBackgroundImage: `linear-gradient(${TILE.RANGE_TRACK_DISABLED_FILLED_COLOR}, ${TILE.RANGE_TRACK_DISABLED_FILLED_COLOR}), linear-gradient(${TILE.RANGE_TRACK_DISABLED_COLOR}, ${TILE.RANGE_TRACK_DISABLED_COLOR})`,
                pointerEvents: OPTIONS.POINTER_EVENTS,
                borderRadius: OPTIONS.BORDER_RADIUS || '4px',
            },
            thumb: {
                ...resolveBackground(TILE.RANGE_THUMB_COLOR),
            },
            disabled: {
                thumb: {
                    ...resolveBackground(TILE.RANGE_THUMB_DISABLED_COLOR),
                },
            },
        },
    };
}

function generateSliderLabels(TILE) {
    const {FONT} = TILE;
    const RANGE_LABEL_TEXT_STYLE = {
        style: {
            fontSize: FONT.SIZE_XSMALL,
            ...TILE.RANGE_LABEL_TEXT,
        },
    };
    return {
        rangeMinLabel: RANGE_LABEL_TEXT_STYLE,
        rangeMinValue: RANGE_LABEL_TEXT_STYLE,
        rangeMaxLabel: RANGE_LABEL_TEXT_STYLE,
        rangeMaxValue: RANGE_LABEL_TEXT_STYLE,
    };
}
